import chunk from 'lodash/chunk';
import pager from '@apps-common/js-client/api/pager';
import request from '@apps-common/js-client/api/request';

import {FOLDERS_API_URL} from '@explorer/config';
import {FOLDER_PAGE_SIZE} from '@explorer/constants/folders';
import {augmentItems} from '@explorer/util/folders';
import {normalizeError} from './util.js';

// Use chunks of 50 items for each request
const FOLDERS_ITEM_ACTIONS_CHUNK_SIZE = 50;

export const moveOrDeleteFolderItems = ({
  folderId,
  toFolder,
  itemIds,
  method,
}) => {
  // Batch requests to API
  const chunks = chunk(itemIds, FOLDERS_ITEM_ACTIONS_CHUNK_SIZE);

  return Promise.all(
    chunks.map(itemIdsArray =>
      request({
        url: `${FOLDERS_API_URL}/${folderId}/items/${itemIdsArray.join(',')}`,
        method: method,
        data: {
          folderId: toFolder,
        },
      }).then(resp => {
        return resp.data;
      })
    )
  ).then(resp => {
    const results = [].concat(...resp.map(result => result.success));
    const errors = [].concat(...resp.map(result => result.fail));

    if (errors.length > 0) {
      return {error: errors};
    }

    return {data: results};
  });
};

export const getAllFolders = () => {
  const config = {
    url: FOLDERS_API_URL,
    params: {
      limit: FOLDER_PAGE_SIZE,
    },
  };
  const allFolders = [];

  const onEach = data => {
    allFolders.push(...data);
  };

  return pager(config, 'folders', onEach)
    .then(() => ({data: allFolders}))
    .catch(err => normalizeError(err));
};

export const getFolderContents = async (folderId, url) => {
  const data = await request
    .get(
      url || `${FOLDERS_API_URL}/${folderId}/contents?limit=${FOLDER_PAGE_SIZE}`
    )
    .then(response => response.data);

  return {
    ...data,
    features: augmentItems(data.features),
  };
};

export const createFolderOrderRequest = (folderId, order) =>
  request
    .post(`${FOLDERS_API_URL}/${folderId}/orders`, order)
    .then(response => response.data);
